import { useState } from "react";

/** Estado genérico dos modais de confirmação e alerta usados na página. */
export default function useDialogs() {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmData, setConfirmData] = useState({
    title: "",
    message: "",
    callback: null,
  });
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertTitle, setAlertTitle] = useState("Pedido Enviado");
  const [alertMessage, setAlertMessage] = useState(
    "Seu pedido foi enviado com sucesso!",
  );

  const showAlert = (type, title, message) => {
    setAlertType(type);
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertModalOpen(true);
  };

  const openConfirm = ({ title, message, callback }) => {
    setConfirmData({ title, message, callback });
    setConfirmModalOpen(true);
  };

  const closeConfirm = () => setConfirmModalOpen(false);

  const runConfirm = () => {
    if (confirmData.callback) confirmData.callback();
  };

  return {
    confirmModalOpen,
    setConfirmModalOpen,
    confirmData,
    openConfirm,
    closeConfirm,
    runConfirm,
    alertModalOpen,
    setAlertModalOpen,
    alertType,
    alertTitle,
    alertMessage,
    showAlert,
  };
}
